import type { FC, ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import type { PageKey } from '../App';

interface AppLayoutProps {
  children: ReactNode;
  currentPage: PageKey;
}

const NAV_ITEMS: Array<{ key: PageKey; label: string }> = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'members', label: 'Members' },
  { key: 'events', label: 'Events' },
  { key: 'passes', label: 'Passes' },
  { key: 'users', label: 'Users' },
  { key: 'drawing', label: 'Drawing' },
  { key: 'attendance', label: 'Attendance' },
];

export const AppLayout: FC<AppLayoutProps> = ({ children, currentPage }) => {
  const { user, logout } = useAuth();

  return (
    <div className="admin-shell">
      <nav className="top-nav" aria-label="Primary">
        <div className="nav-top">
          <div className="brand-row">
            <div className="ou-mark">OU</div>
            <div>
              <p className="nav-brand">Sooner Nation Admin</p>
              <p className="nav-subbrand">OU Club of Collin County</p>
            </div>
          </div>
          <div className="connection-status">
            Connected as <strong>{user?.displayName ?? 'Unknown user'}</strong>
          </div>
        </div>
        <div className="nav-links">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.key}
              href={`#${item.key}`}
              className={`nav-item ${currentPage === item.key ? 'active' : ''}`}
              aria-current={currentPage === item.key ? 'page' : undefined}
            >
              {item.label}
            </a>
          ))}
          <button type="button" className="nav-item nav-logout" onClick={logout}>
            Logout
          </button>
        </div>
      </nav>
      <div className="layout">
        <main className="main">{children}</main>
      </div>
    </div>
  );
};
